import React from 'react';
import Reports from '../../components/Reports';

const index = () => {
	return (
		<div>
			<Reports />
		</div>
	);
};

export default index;
